import { render, staticRenderFns } from "./permutationOld.vue?vue&type=template&id=07453f08&scoped=true&"
import script from "./permutationOld.vue?vue&type=script&lang=js&"
export * from "./permutationOld.vue?vue&type=script&lang=js&"
import style0 from "./permutationOld.vue?vue&type=style&index=0&id=07453f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07453f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07453f08')) {
      api.createRecord('07453f08', component.options)
    } else {
      api.reload('07453f08', component.options)
    }
    module.hot.accept("./permutationOld.vue?vue&type=template&id=07453f08&scoped=true&", function () {
      api.rerender('07453f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/permutationOld.vue"
export default component.exports